import { useEffect, useRef } from 'react';
import logo from '../assets/megedLogoTransp.png';
import splash from '../assets/megedSplash.png';

const stats = [
    { num: '1000+', label: 'לקוחות מרוצים' },
    { num: '20', label: 'יעדים בעולם' },
    { num: '12', label: 'שנות ניסיון' },
    { num: '4.9★', label: 'דירוג ממוצע' },
];

export default function Hero() {
    const textRef = useRef(null);
    const visRef = useRef(null);

    useEffect(() => {
        [textRef.current, visRef.current].filter(Boolean).forEach((el, i) => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(28px)';
            setTimeout(() => {
                el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
                el.style.opacity = '1';
                el.style.transform = 'none';
            }, 120 + i * 160);
        });
    }, []);

    const scrollTo = (id) =>
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

    return (
        <section id="home" className="min-h-screen bg-brand-beige-light flex items-center
                                   pt-24 pb-16 px-6 relative overflow-hidden">
            <div className="absolute w-[600px] h-[600px] rounded-full bg-brand-beige
                      -top-40 -right-40 opacity-60 pointer-events-none" />
            <div className="absolute w-[360px] h-[360px] rounded-full border-2 border-brand-blue
                      opacity-[0.07] -bottom-28 left-[12%] pointer-events-none" />

            <div className="max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-16
                      items-center relative z-10">
                <div ref={textRef}>



                    <h1 className="font-display font-bold leading-[1.2] tracking-tight text-gray-900 mb-5">
                        <span className="block text-[clamp(1.4rem,2.5vw,2rem)] font-light mb-2">
                            הטיול שחלמתם עליו ולא ידעתם מאיפה להתחיל —
                        </span>
                        <span className="block text-[clamp(2.4rem,4.5vw,4rem)]">
                            אנחנו ב{' '}
                            <em className="not-italic text-brand-blue font-body tracking-normal">מֶּגֶד שָׁמַיִם</em>{' '}
                            ניצור אותו עבורכם...
                        </span>
                    </h1>

                    <p className="font-body font-light text-lg text-gray-500 leading-relaxed mb-6 max-w-md">
                        מתמחים בתכנון חופשות יוקרה יהודיות מותאמות אישית. <br /> אנחנו דואגים לכל פרט, מבחירת היעד, דרך המסלול המדויק בדיוק עבורכם,  ועד ליצירת חוויות יוצאות דופן שנבנו בדיוק לפי הבקשות המיוחדות והערכים שלכם.
                    </p>

                    

                    <div className="flex gap-4 flex-wrap">
                        <button
                            onClick={() => scrollTo('#app')}
                            className="bg-brand-blue hover:bg-brand-blue-dark text-white
                         font-body font-semibold text-base px-8 py-4 rounded-full
                         shadow-[0_4px_20px_rgba(43,75,170,0.30)]
                         hover:shadow-[0_8px_28px_rgba(43,75,170,0.40)]
                         hover:-translate-y-0.5 transition-all duration-200"
                        >
                            גלה את האפליקציה שלנו
                        </button>
                        <button
                            onClick={() => scrollTo('#contact')}
                            className="border-[1.5px] border-brand-blue text-brand-blue
                         font-body font-semibold text-base px-8 py-4 rounded-full
                         hover:bg-brand-blue-light transition-colors duration-200"
                        >
                            השאר פרטים
                        </button>
                    </div>

                    <div className="flex gap-8 mt-12 pt-8 border-t border-brand-blue/10 flex-wrap">
                        {stats.map(({ num, label }) => (
                            <div key={label} className="text-center">
                                <div className="font-display font-bold text-[1.9rem] leading-none text-brand-blue">
                                    {num}
                                </div>
                                <div className="font-body text-xs text-gray-400 mt-1 font-light">
                                    {label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div ref={visRef} className="hidden md:flex items-center justify-center relative">
                    <div className="w-[400px] h-[400px] rounded-full border-2 border-brand-blue/15
                flex items-center justify-center">
                        <img src={logo} alt="מגד שמיים" className="w-[380px] h-[380px] object-contain mix-blend-multiply" />
                    
                    
                    </div>
                </div>
            </div>
        </section>
    );
}